import Cookies from "universal-cookie";
import { DateTime } from "luxon";
import { CookieSetOptions, CookieGetOptions } from "universal-cookie/es6/types";
import { MD_REFRESH_TOKEN, MD_ACCESS_TOKEN } from "../static/constant/tokens";

export const cookies = new Cookies();

export interface AccessTokenOptions {
  expires_in: number;
}

export function setRefreshToken(token: string, options?: CookieSetOptions): void {
  cookies.set(MD_REFRESH_TOKEN, token, options);
}

export function getRefreshToken(options?: CookieGetOptions): string {
  return cookies.get(MD_REFRESH_TOKEN, options);
}

export function removeRefreshToken() {
  cookies.remove(MD_REFRESH_TOKEN, { path: "/" });
}

export function setAccessToken(token: string, options: AccessTokenOptions): void {
  const expireMillis = DateTime.local().toMillis() + options.expires_in;
  localStorage.setItem(
    MD_ACCESS_TOKEN,
    JSON.stringify({
      token,
      expire: expireMillis,
    })
  );
}

export function getAccessToken(): string | null {
  const { token, expire } = JSON.parse(localStorage.getItem(MD_ACCESS_TOKEN) || "{}");
  if (token && expire > DateTime.local().toMillis()) {
    return token;
  }
  return null;
}

export function clearTokens(): void {
  cookies.remove(MD_ACCESS_TOKEN, { path: "/" });
  cookies.remove(MD_REFRESH_TOKEN, { path: "/" });
}
